import React from 'react';
import SelectEntityFactory from '../Common/SelectEntityFactory';
import UserActions from '../../actions/UserActionCreator';
import { formatName } from '../../utils/StringUtils';
import { SearchTypes } from "../../constants/CentricConstants";

export default SelectEntityFactory(UserActions.search, {minInput: 3, getTextValue: formatName, searchType: SearchTypes.USERS});
